// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__11L4g","text":"SelectPayment_text__ZtkUB","title":"SelectPayment_title__vrxU2","btn":"SelectPayment_btn__5YSAG"};